import apiUrl from '../../../constants'
import axios from 'axios'
//import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import Loader from './../shared/loader'
import moment from 'moment'
import Pagination from './../shared/pagination'

export default {
	name: 'supportrequest',
	components: {
		Pagination,
		DatePicker,
		Loader
	},
	data: function() {
		return {
			orderiDS: [],
			MultiorderBoxIDS: '',
			MultiorderBoxIDSArr: [],
			finalarrayofmultipleBOxids: [],
			MultiorderIDS: '',
			MultiorderArr: [],
			finalarrayofmultipleorder: [],
			rtdorderids: [],
			showSelectWarehouse: false,
			listClientData: [],
			modalShow: false,
			status: '',
			WarehouseErr: '',
			showSelectClient: false,
			isLoading: false,
			is_Loading: false,
			resultCount: '',
			warehousesearch: '',
			warehousename: '',
			orderid: '',
			listWarehouseData: [],
			clientid: '',
			ClientErr: '',
			Requesttype: '',
			Clientname: '',
			statusupdate: '',
			BoxID: '',
			dispatchedbyuser:'',
			dispatchedtouser:'',
			orderidlistArr:[],
			orderidlist:'',
			OverOrdersErr:'',
			MultiorderArrFlag: false,
			purchaseorderidlist: '',
			purchaseorderidArr:[],
			purchaseorderidlistErr:'',
			couriername:'',
			awbno:'',
			custname:'',
			totalquantity:'',
			sku:'',
			orderid1:'',
			resultArr:[],
			shpmtidArr:[],
			buttonflag: false,
			formattedDate:'',
			listCourierData:[],
			RackID:'',
			ProductID:'',
			ExpiryDate:'',
			returnsType:'',
			returnType :'',
			awbnumber : '',
			racktype : '',
			delorderid : '',
			delproductid : '',
			delitemid : '',
			delboxid : '',
			invreferenceid : '',
            removeacceptqty : 0,
			removerejectqty : 0,
			grnitemid :0,
			removeshortqty : 0,
			grnproductid : 0,
			pushorderid : '',
			user_type : '',
			skustring:[],
			pickerListData: '',
			pickerid:'',
			ordertext: '',
			orderTextErr:'',
			SelectPickerErr:'',
			error: false
			//count:0
		}
	},
	computed: {
            count() {
					return this.ordertext
						.split(',')
						.map(s => s.trim())
						.filter(s => s !== '')
						.length;
           },
		   ordertextArray() {
				return this.ordertext
				.split(',')
				.map(s => s.trim())
				.filter(s => s !== '');
			}
	},
	 watch: {
			ordertext() {
				this.validateInput();
			}
	},
	created: function() {},
	// when a page loads,mounted() will be call
	mounted() {
		this.pageno = 0
		var today = new Date();
		this.formattedDate = moment(today).format('YYYY-MM-DD HH:mm:ss')
		// this.getClientList()
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.useremail = userdetail.email;
		this.userid = userdetail.userid
		// var temp = this.useremail.split('/');
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		this.user_type = userdetail.utype;
		this.getcourierlist();
		this.getPickersList();
		switch (this.user_type) {
			case 'system_user':
				this.showSelectWarehouse = true;
				this.showSelectClient = true;
				// this.getWarehouseList();
				// this.getClientList();

				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				// this.getClientList();

				// this.getWarehouseList();
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.showSelectWarehouse = false;
				this.showSelectClient = true;
				// this.getClientList();



				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error("Unauthorised user, Please contact your system admin");
				break
		}
	},
	methods: {
		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},
		validateInput() {	
	      if (typeof this.ordertext === 'string' && this.ordertext != null && this.ordertext !== '') {
                const parts = this.ordertext.split(',').map(s => s.trim()).filter(s => s !== '');
				if (parts.length >= 400) {
					this.error = true;
					this.orderTextErr = 'You can only enter up to 400 order IDs.';
					this.ordertext = parts.slice(0, 400).join(', ');
				} else if (parts.length === 0) {
					this.error = true;
					this.orderTextErr = 'Order IDs required';
				} else {
					this.error = false;
					this.orderTextErr = '';
				}
			}
		 },
		// getClientList() {
		// 	this.pageno = 0;


		// 	var userToken = window.localStorage.getItem('userToken');
		// 	var myStr = userToken.replace(/"/g, '');
		// 	this.input = ({
		// 		warehouseid: this.warehouseid,
		// 	});

		// 	axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 		.then(result => {
		// 			this.listClientData = result.data.data;
		// 		}, error => {
		// 			console.error(error);
		// 		});

		// },


		changetype() {
			this.Clientname = '';
			this.orderid = '';
			this.statusupdate = '';
			this.warehousename = '';
			this.BoxID = '';
		},
		// clientSelected() {
		//
		//
		// 	if (this.user_type != 'warehouse_user') {
		// 		this.listWarehouseData = []
		// 		this.getWarehouseList();
		// 		if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 			this.warehouse = this.warehouseid = '';
		// 		} else {
		// 			this.warehouse = ''
		// 		}
		// 	} else {
		// 		if (this.warehouseid && this.clientid);
		// 		// this.getCancelPutawayReportData();
		// 	}
		//
		//
		// },

		// clientSelected() {
		// 	this.orderid = '';
		// 	this.BoxID = '';
		// 	if (this.Clientname != this.Clientname ||this.Clientname == this.Clientname) {
		// 		this.clientid = this.Clientname;
		// 		this.listWarehouseData = []
		// 		this.warehousename = '';
		// 		this.getWarehouseList();
		// 		if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 			this.warehouse = this.warehouseid = '';
		// 		}
		// 	}

		// 	this.clientid = this.Clientname;
		// 	if (this.clientid) {
		// 		//this.resetaddDeatilsForm();
		// 		this.getcourierlist();
		// 		if (this.warehouseid) {
		// 			//this.getRTOListSearch();

		// 		} else {
		// 			this.getWarehouseList();

		// 		}
		// 	}
		// },



		// getWarehouseList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');

		// 		this.input = ({
		// 			'clientid': this.Clientname,
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },


		dateFormat(date, toFrom) {
			if (!toFrom)
				toFrom = '00:00:00'
			else
				toFrom = '23:59:59'
			if (!date)
				return '';
			return moment(date).format('YYYY-MM-DD ' + toFrom);
		},

		unpackBoxid() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.pageno = 0;
			this.isLoading = true;
			// if (this.showSelectWarehouse == true) {
			// 	this.warehouseid = this.warehousename
			// }
			this.input = ({
				'warehouseid': localStorage.getItem("selectedWarehouse"),
				'clientid': this.client,
				'boxid': this.BoxID,

			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'unpackingboxid',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					if (result.data.data[0].ErrorCode == 0) {
						this.$alertify.success(result.data.data[0].msg)
						this.BoxID = '';

					} else if (result.data.data[0].ErrorCode == -1) {
						this.$alertify.error(result.data.data[0].msg)

					}

					this.isLoading = false;
				}, error => {
					console.error(error);
				});

		},

		restoreorder() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			console.log(this.warehouseid, 'this.warehouseid');
			// if (this.showSelectWarehouse == true) {
			// 	this.warehouseid = this.warehousename
			// }
			this.pageno = 0;
			this.isLoading = true;
			this.input = ({
				'warehouseid': localStorage.getItem("selectedWarehouse"),
				'clientid': this.client,
				'orderid': this.orderid,
				'boxid': this.BoxID,
				'userid': this.userid,

			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'restoreOrderCancel',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					if (result.data.data.ErrorCode == 0) {
						this.$alertify.success(result.data.data.msg)

					} else if (result.data.data.ErrorCode == -1) {
						this.$alertify.error(result.data.data.msg)

					}

					this.isLoading = false;
				}, error => {
					console.error(error);
				});
		},

		CheckStacusandSave() {
			if (this.statusupdate == 'Unpack') {
				this.unpackBoxid();
			}
			if (this.statusupdate == 'Restore') {
				this.restoreorder();
			}
			if (this.statusupdate != 'Restore' && this.Requesttype != 'PODeletion' && this.statusupdate != 'Unpack' && this.Requesttype != 'getorderfrommultiseller' && this.Requesttype != 'Multisellerpackingdetails' && this.Requesttype != 'Filpcartpushorder' && this.Requesttype != 'FilpcartRTD' && this.Requesttype != 'FilpcartDispatched' && this.Requesttype != 'Uniwareorderpush' && this.Requesttype != 'UniwareInventarySink' && this.Requesttype != 'RTOInScanIssue' && this.Requesttype != 'UpdateExpiry') {
				this.saveRequest();
			}
			if (this.Requesttype == 'getorderfrommultiseller') {
				this.getorderfrommultiseller();
			}
			if (this.Requesttype == 'Multisellerpackingdetails') {
				this.getmultisellerpackingDetails();
			}
			if (this.Requesttype == 'Filpcartpushorder') {
				this.filpcartPushorder();
			}
			if (this.Requesttype == 'FilpcartRTD') {
				this.FilpcartRTD();
			}
			if (this.Requesttype == 'FilpcartDispatched') {
				this.FilpcartDispatched();
			}
			if (this.Requesttype == 'Uniwareorderpush') {
				this.uniwareOrderPush();
			}
			if (this.Requesttype == 'UniwareInventarySink') {
				this.uniwareInventarySink();
			}
			if (this.Requesttype == 'PODeletion') {
				this.PODeletion();
			}
			if (this.Requesttype == 'RTOInScanIssue') {
				this.RTOInScanIssue();
			}
			if (this.Requesttype == 'UpdateExpiry') {
				this.UpdateExpiry();
			}
			if (this.Requesttype == 'UpdateReturnExpiry') {
				this.UpdateReturnExpiry();
			}
			if (this.Requesttype == 'returnsPutAwayIssue') {
				this.resolveReturnsPutAwayIssue();
			}
			if (this.Requesttype == 'deleteOrder') {
				this.resolveDeleteOrder();
			}
			if (this.Requesttype == 'resolveExcessgrn') {
				this.resolveExcessGrn();
			}
			if (this.Requesttype == 'updateImageUniToWMS') {
				this.updateImageUniToWMS();
			}
			if (this.Requesttype == 'pickerAssignmentBulk') {
				this.pickerAssignmentBulk();
			}
		},

		async PODeletion(){
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.finalarrayofmultipleorder= [],
			this.isLoading = true;
			await this.$validator.validateAll().then((result) => {
				if (!result) {
					console.log('form is invalid 1' , this.model)
					return false;
				} else{
					if (this.purchaseorderidlist == '') {
						this.purchaseorderidArr = [];
					}
					if (this.purchaseorderidlist && this.purchaseorderidlist.indexOf(",") > -1) {
						this.purchaseorderidArr = this.purchaseorderidlist.split(",")
					}
					if (this.purchaseorderidlist && this.purchaseorderidlist.indexOf(",") == -1) {
						this.purchaseorderidArr = this.purchaseorderidlist.split(",")
					}
					for (var i = 0; i < this.purchaseorderidArr.length; i++) {
						if (this.finalarrayofmultipleorder.indexOf(this.purchaseorderidArr[i]) == -1) {
							this.finalarrayofmultipleorder.push(this.purchaseorderidArr[i])
						}
					}
					// if (this.showSelectWarehouse == true) {
					// 	this.warehouseid = this.warehousename
					// }
					this.input = ({
						'clientid': this.client,
						'warehouseid': localStorage.getItem('selectedWarehouse'),
						'poidlist': this.finalarrayofmultipleorder,
					})

					axios({
						method: 'POST',
						'url' : apiUrl.api_url + 'deleteMultiplePO',
						'data': this.input,
					headers: {
					'Content-Type' : 'application/json',
					'Authorization': 'Bearer ' + myStr
				},
			})
			.then(result => {
				if(result.data.errorCode == -1) {
					this.listStockReportData = [];
					this.resultCount = 0;
					this.totalRows = 0;
					this.$alertify.error(result.data.msg);
				} else {
					this.$alertify.success("Successfully Deletion of total IDs : "+result.data.msg);
					if (result.data.msg1.length > 0){
					let response1 = JSON.stringify(result.data.msg1);
					response1 = response1.replace(/,/g,', ');
					this.$alertify.error(" Invalid IDs : "+response1);
					}
					this.resetaddDeatilsForm();
				}
				this.isLoading = false;
			}, error => {
				console.log(error);
			})
				}
			}).catch(() => {
				console.log('error exist', this.errors)
			});
		},

		filpcartPushorder() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.isLoading = true;
			this.$validator.validateAll().then((result) => {
				if (!result) {
					console.log('form is invalid 2', this.model)
					return false;
				} else {
					this.input = ({
						"clientid": this.client,

					})
					axios({
							method: 'POST',
							'url': apiUrl.api_url + 'getFilpcartOrderAllocationForSupport',
							'data': this.input,
							headers: {
								'Authorization': 'Bearer ' + myStr
							}
						})
						.then(result => {
							if (result.data.data[0].ErrorCode == -1) {
								this.listStockReportData = [];
								this.resultCount = 0;
								this.totalRows = 0;
								this.$alertify.error(result.data.data[0].msg);
							} else {
								this.$alertify.success(result.data.data[0].msg);
							}
							this.isLoading = false;
						}, error => {
							console.error(error);
						})
				}
			}).catch(() => {
				console.log('errors exist', this.errors)
			});

		},
		async RTOInScanIssue(){
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.isLoading = true;
			this.resultArr = [];
			this.shpmtidArr = [];
			await this.$validator.validateAll().then((result) => {
				if (!result) {
					console.log('form is invalid 3' , this.model)
					return false;
				} else{
					// if (this.showSelectWarehouse == true) {
					// 	this.warehouseid = this.warehousename
					// }
					this.input = ({

						'warehouseid': localStorage.getItem("selectedWarehouse"),
						"awbno" : this.awbno,
						"couriername" : this.couriername
					})

					axios({
						method: 'POST',
					'url' : apiUrl.api_url + 'checkawbnoReturn',
					'data': this.input,
			headers: {
				'Content-Type' : 'application/json',
				'Authorization': 'Bearer ' + myStr
				},

			})
			.then(result => {
				this.resultArr = result;
				if(result.data.errorCode == -1) {
					this.listStockReportData = [];
					this.resultCount = 0;
					this.totalRows = 0;
					this.$alertify.error(result.data.msg);
				} else {
					this.orderid1 = result.data.data.master[0].orderid
					this.sku = result.data.data.sku
					this.totalquantity = result.data.data.totalquantity
					let lastname = '';
					if((result.data.data.master[0].customerlastname = '') || (result.data.data.master[0].customerlastname = null))
					{
						lastname = '';
					}
					 else{
						 result.data.data.master[0].customerlastname == lastname
						}
					this.custname = result.data.data.master[0].customerfirstname + " " + lastname
					this.$alertify.success(result.data.msg);
					this.buttonflag = true;
				}
				this.isLoading = false;
			}, error => {
				console.log(error);
			})
				}
			}).catch(() => {
				console.log('error exist', this.errors)
			});

		},

		async uniwareInventarySink(){
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.isLoading = true;
			await this.$validator.validateAll().then((result) => {
				if (!result) {
					console.log('form is invalid 4' , this.model)
					return false;
				} else{
					// if (this.showSelectWarehouse == true) {
					// 	this.warehouseid = this.warehousename
					// }
					this.input = ({
						'clientid': this.client,
						'warehouseid': localStorage.getItem("selectedWarehouse"),
						'batchsize': 2700,
						'useremail': this.useremail,
					})

					axios({
						method: 'POST',
					'url' : apiUrl.api_url + 'bulkInventaryUpdateUnicommerce',
				'data': this.input,
			headers: {
				'Content-Type' : 'application/json',
				'Authorization': 'Bearer ' + myStr
				},
				// 'json': true,
				// 'body': option.headers.body
			})
			.then(result => {
				console.log(result.data)
				if(result.data.errorCode == -1) {
					this.listStockReportData = [];
					this.resultCount = 0;
					this.totalRows = 0;
					this.$alertify.error(result.data.data.msg);
				} else {
					this.$alertify.success(result.data.data.msg);
				}
				this.isLoading = false;
			}, error => {
				console.log(error);
			})
				}
			}).catch(() => {
				console.log('error exist', this.errors)
			});

		},
		async FinalInScan(){
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.isLoading = true;
			console.log('ab1111')
			if(this.user_type == 'warehouse_user'){
				// this.warehouseid = userdetail.warehouseid;
				this.warehousename = this.warehouseid

			}

			await this.$validator.validateAll().then((result) => {
				console.log('abcccc')
				if (!result) {
					console.log('form is invalid 5' , this.model)
					return false;
				} else{
					var shippingArr = this.resultArr.data.data.shippingid;

					shippingArr.forEach(ele => {
					this.shpmtidArr.push({"shippingid": ele.shippingid})
					});
					// if (this.showSelectWarehouse == true) {
					// 	this.warehouseid = this.warehousename
					// }

					this.input = ({
						"orderid": this.orderid1,
						"awbno": this.awbno,
						"customerfirstname": this.resultArr.data.data.master[0].customerfirstname ,
						"customerlastname": this.resultArr.data.data.master[0].customerlastname ,
						"transporter": this.couriername,
						"createdby": this.user_type,
						"createddatetime": this.formattedDate,
						"warehouseid": localStorage.getItem("selectedWarehouse"),
						"boxcondition": "Good",
						"sku": this.resultArr.data.data.sku,
						"quantity": this.resultArr.data.data.totalquantity,
						"shippingid": JSON.stringify(this.shpmtidArr),
						"clientid": this.client,

					});

					axios({
						method: 'POST',
					'url' : apiUrl.api_url + 'SaveRTO',
				'data': this.input,
			headers: {
				'Content-Type' : 'application/json',
				'Authorization': 'Bearer ' + myStr
				},

			})
			.then(result => {
				console.log(result.data)
				if(result.data.errorCode == -1) {
					this.listStockReportData = [];
					this.resultCount = 0;
					this.totalRows = 0;
					this.$alertify.error(result.data.msg);
				} else {
					this.$alertify.success(result.data.msg);
					this.resetaddDeatilsForm();
				}
				this.isLoading = false;
			}, error => {
				console.log(error);
			})
				}
			}).catch(() => {
				console.log('error exist', this.errors)
			});

		},

		uniwareOrderPush() {
		 var userToken = window.localStorage.getItem('userToken')
		 var myStr = userToken.replace(/"/g, '');
		 this.isLoading = true;
		 this.$validator.validateAll().then((result) => {
			 if (!result) {
				 console.log('form is invalid 6', this.model)
				 return false;
			 } else {
				    this.input = ({
					    clientid: Number(this.client),
                        warehouseid : Number(localStorage.getItem("selectedWarehouse")),
						orderid : this.pushorderid
				    })

				 axios({
						 method: 'POST',
						 'url': apiUrl.api_url + 'pushSingleUniwareOrderToWMS',
						 'data': this.input,
						 headers: {
							 'Authorization': 'Bearer ' + myStr
						 }
					 })
					 .then(result => {
						 if (result.data.errorCode == -1) {
							 this.listStockReportData = [];
							 this.resultCount = 0;
							 this.totalRows = 0;
							 this.$alertify.error(result.data.msg);
						 } else {
							 this.$alertify.success(result.data.msg);
						 }
						 this.isLoading = false;
					 }, error => {
						 console.error(error);
					 })
			 }
		 }).catch(() => {
			 console.log('errors exist', this.errors)
		 });

	 },

		FilpcartRTD() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.isLoading = true;
			this.$validator.validateAll().then((result) => {
				if (!result) {
					console.log('form is invalid 7', this.model)
					return false;
				} else {
					if (this.MultiorderIDS == '') {
						this.MultiorderArr = [];
					}
					if (this.MultiorderIDS && this.MultiorderIDS.indexOf(",") > -1) {
						this.MultiorderArr = this.MultiorderIDS.split(",")
					}
					if (this.MultiorderIDS && this.MultiorderIDS.indexOf(",") == -1) {
						this.MultiorderArr = this.MultiorderIDS.split(",")
					}
					for (var i = 0; i < this.MultiorderArr.length; i++) {
						if (this.finalarrayofmultipleorder.indexOf(this.MultiorderArr[i]) == -1) {
							this.finalarrayofmultipleorder.push(this.MultiorderArr[i])
						}
					}
					// if (this.showSelectWarehouse == true) {
					// 	this.warehouseid = this.warehousename
					// }
					this.input = ({
						'clientid': this.client,
						'warehouseid': localStorage.getItem("selectedWarehouse"),
						'orderids': this.finalarrayofmultipleorder,
					})
					axios({
							method: 'POST',
							'url': apiUrl.api_url + 'getFilpcartRTDForSupport',
							'data': this.input,
							headers: {
								'Authorization': 'Bearer ' + myStr
							}
						})
						.then(result => {
							if (result.data.data[0].ErrorCode == -1) {
								this.listStockReportData = [];
								this.resultCount = 0;
								this.totalRows = 0;
								this.$alertify.error(result.data.data[0].msg);
							} else {
								this.$alertify.success(result.data.data[0].msg);
							}
							this.isLoading = false;
						}, error => {
							console.error(error);
						})
				}
			}).catch(() => {
				console.log('errors exist', this.errors)
			});

		},

		FilpcartDispatched() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.isLoading = true;
			this.$validator.validateAll().then((result) => {
				if (!result) {
					console.log('form is invalid 8', this.model)
					return false;
				} else {
					if (this.MultiorderBoxIDS == '') {
						this.MultiorderBoxIDSArr = [];
					}
					if (this.MultiorderBoxIDS && this.MultiorderBoxIDS.indexOf(",") > -1) {
						this.MultiorderBoxIDSArr = this.MultiorderBoxIDS.split(",")
					}
					if (this.MultiorderBoxIDS && this.MultiorderBoxIDS.indexOf(",") == -1) {
						this.MultiorderBoxIDSArr = this.MultiorderBoxIDS.split(",")
					}
					for (var i = 0; i < this.MultiorderBoxIDSArr.length; i++) {
						if (this.finalarrayofmultipleBOxids.indexOf(this.MultiorderBoxIDSArr[i]) == -1) {
							this.finalarrayofmultipleBOxids.push(this.MultiorderBoxIDSArr[i])
						}
					}
					// if (this.showSelectWarehouse == true) {
					// 	this.warehouseid = this.warehousename
					// }
					this.input = ({
						"clientid": this.client,
						"warehouseid": localStorage.getItem("selectedWarehouse"),
						"dispatchedtouser": this.dispatchedtouser,
						"dispatchedbyuser": this.dispatchedbyuser,
						"boxids": this.finalarrayofmultipleBOxids


					})
					axios({
							method: 'POST',
							'url': apiUrl.api_url + 'getDispatchedOrder',
							'data': this.input,
							headers: {
								'Authorization': 'Bearer ' + myStr
							}
						})
						.then(result => {
							if (result.data.data[0].ErrorCode == -1) {
								this.listStockReportData = [];
								this.resultCount = 0;
								this.totalRows = 0;
								this.$alertify.error(result.data.data[0].msg);
							} else {
								this.$alertify.success(result.data.data[0].msg);
							}
							this.isLoading = false;
						}, error => {
							console.error(error);
						})
				}
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		},

		onclientselected() {
			this.orderid = '';
			this.BoxID = '';
		},

		getorderfrommultiseller() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			// this.ClientErr = '';
			// var str = "How are you doing today?";
			//  var res = str.split(" ", 3);
			this.orderid = this.orderid.split(",")

			this.isLoading = true;
			// this.orderiDS.push(this.orderid)

			this.input = ({
				"clientid": this.client,
				"warehouseid": localStorage.getItem("selectedWarehouse"),
				"orderid": this.orderid,

				// 'csvData': csvCheck,
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getMultisellerOrderDetailsForSupport',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data.data[0].ErrorCode == -1) {
						this.listStockReportData = [];
						this.resultCount = 0;
						this.totalRows = 0;
						this.$alertify.error(result.data.data[0].msg);
					} else {
						this.$alertify.success(result.data.data[0].msg);

					}
					this.isLoading = false;
				}, error => {
					console.error(error);
				})
		},

		getmultisellerpackingDetails() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.isLoading = true;

			this.input = ({
				"clientid": this.client,
				"warehouseid": localStorage.getItem("selectedWarehouse"),
				"orderid": this.orderid.toString(),
				"boxid": this.BoxID
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getMultisellerpackingForSupport',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					console.log(result.data.data[0].msg);
					if (result.data.data[0].ErrorCode == -1) {
						this.listStockReportData = [];
						this.resultCount = 0;
						this.totalRows = 0;
						this.$alertify.error(result.data.data[0].msg);
					} else {
						this.$alertify.success(result.data.data[0].msg);


					}
					this.isLoading = false;
				}, error => {
					console.error(error);
				})
		},
		CountPOIDs(){
			this.finalarrayofmultipleorder= [];
			if (this.purchaseorderidlist && this.purchaseorderidlist.indexOf(",") > -1) {
				this.purchaseorderidArr = this.purchaseorderidlist.split(",")
			}
			if (this.purchaseorderidlist && this.purchaseorderidlist.indexOf(",") == -1) {
				this.purchaseorderidArr = this.purchaseorderidlist.split(",")
			}
			for (var i = 0; i < this.purchaseorderidArr.length; i++) {
				if (this.finalarrayofmultipleorder.indexOf(this.purchaseorderidArr[i]) == -1) {
					this.finalarrayofmultipleorder.push(this.purchaseorderidArr[i])
				}
			}
					if(this.finalarrayofmultipleorder.length > 50){
						this.MultiorderArrFlag = true;
						this.OverOrdersErr = "Only 50 orders at a time";
					}
					else {
						this.MultiorderArrFlag = false;
					}
		},

		CountOrderIDs(){
			this.finalarrayofmultipleorder= [];
			if (this.orderidlist && this.orderidlist.indexOf(",") > -1) {
				this.orderidlistArr = this.orderidlist.split(",")
			}
			if (this.orderidlist && this.orderidlist.indexOf(",") == -1) {
				this.orderidlistArr = this.orderidlist.split(",")
			}
			for (var i = 0; i < this.orderidlistArr.length; i++) {
				if (this.finalarrayofmultipleorder.indexOf(this.orderidlistArr[i]) == -1) {
					this.finalarrayofmultipleorder.push(this.orderidlistArr[i])
				}
			}
					if(this.finalarrayofmultipleorder.length > 50){
						this.MultiorderArrFlag = true;
						this.OverOrdersErr = "Only 50 orders at a time";
					}
					else {
						this.MultiorderArrFlag = false;
					}
		},

		saveRequest() {

			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.finalarrayofmultipleorder= [],
			this.$validator.validateAll().then((result) => {
				if (!result) {
					console.log('form is invalid 9', this.model)
					return false;
				} else {
					if (this.orderidlist == '') {
						this.orderidlistArr = [];
					}
					if (this.orderidlist && this.orderidlist.indexOf(",") > -1) {
						this.orderidlistArr = this.orderidlist.split(",")
					}
					if (this.orderidlist && this.orderidlist.indexOf(",") == -1) {
						this.orderidlistArr = this.orderidlist.split(",")
					}
					for (var i = 0; i < this.orderidlistArr.length; i++) {
						if (this.finalarrayofmultipleorder.indexOf(this.orderidlistArr[i]) == -1) {
							this.finalarrayofmultipleorder.push(this.orderidlistArr[i])
						}
					}
					if (this.showSelectWarehouse == true) {
						this.warehouseid = this.warehousename
					}

					axios({
							method: 'POST',
							'url': apiUrl.api_url + 'requestupdate',
							'data': {
								'warehouseid': localStorage.getItem("selectedWarehouse"),
								'clientid': this.client,
								'orderid': this.orderid,
								'userid': this.userid,
								'statusupdate': this.statusupdate,
								'requesttype': this.Requesttype,
								'BoxID': this.BoxID,
								"orderidlist":this.finalarrayofmultipleorder,
							},
							headers: {
								'Authorization': 'Bearer ' + myStr
							}
						})
						.then((response) => {
							if (response.data.errorCode == 0) {
								this.is_Loading = false;
								if (response.data.type && response.data.type == 'multi'){
									if (response.data.msg2.length > 0){
										let response2 = JSON.stringify(response.data.msg2);
										response2 = response2.replace(/,/g,', ')
										this.$alertify.success(response.data.msg+" Of IDs :"+response2);
								  }
								}else{
									this.$alertify.success(response.data.msg)
								}
								if (response.data.msg1 && response.data.msg1.length > 0){
								let response1 = JSON.stringify(response.data.msg1);
								response1 = response1.replace(/,/g,', ')
								this.$alertify.error(" Invalid IDs :"+response1);
								}
								this.resetaddDeatilsForm();

							} else if (response.data.errorCode == -1) {
								this.is_Loading = false
								this.$alertify.error(response.data.msg)
								this.resetaddDeatilsForm();

							}
						})
						.catch((httpException) => {
							console.error('exception is:::::::::', httpException)
						})
				}

			}).catch(() => {
				console.log('errors exist', this.errors)
			});



		},
		getcourierlist() {
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				return false;
			}

			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				return false;
			}
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.pageno = 0;
			if (this.showSelectWarehouse == true) {
				this.warehouseid = this.warehousesearch
			}
			this.input = ({
				warehouseid: localStorage.getItem("selectedWarehouse"),
				clientid:this.client
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'courierMasterList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					this.listCourierData = result.data.data.rows;
				}, error => {
					console.error(error);
				});
		},
		UpdateExpiry() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.pageno = 0;
			if (this.showSelectWarehouse == true) {
				this.warehouseid = this.warehousename
			}
			this.$validator.validateAll().then((result) => {
				if (!result) {
					console.log('form is invalid', this.model)
					return false;
				} else {
					if(this.ExpiryDate != ''){
						this.ExpiryDate = moment(this.ExpiryDate).format('YYYY-MM-DD')

					}

						this.input = ({
							warehouseid: localStorage.getItem("selectedWarehouse"),
							clientid:this.client,
							rackid:this.RackID,
							productid:this.ProductID,
							expirydate:this.ExpiryDate,
							useremail: this.useremail,
						});
						axios({
								method: 'POST',
								'url': apiUrl.api_url + 'updateProductExpiry',
								'data': this.input,
								headers: {
									'Authorization': 'Bearer ' + myStr,
								}
							})
							.then(response => {
								if (response.data.errorCode == 0) {
									this.is_Loading = false
									this.$alertify.success(response.data.msg)
									// if (response.data.msg1.length > 0){
									// let response1 = JSON.stringify(response.data.msg1);
									// response1 = response1.replace(/,/g,', ')
									// this.$alertify.error(" Invalid IDs :"+response1);
									// }
									this.resetaddDeatilsForm();

								} else if (response.data.errorCode == -1) {
									this.is_Loading = false
									this.$alertify.error(response.data.msg)
									this.resetaddDeatilsForm();

								}
							}, error => {
								console.error(error);
							});
						}
					}).catch(() => {
						console.log('error exist', this.errors)
					});
		},
		UpdateReturnExpiry() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.pageno = 0;
			if (this.showSelectWarehouse == true) {
				this.warehouseid = this.warehousename
			}
			this.$validator.validateAll().then((result) => {
				if (!result) {
					console.log(result);
					console.log('form is invalid', this.model)
					return false;
				} else {
					if(this.ExpiryDate != ''){
						this.ExpiryDate = moment(this.ExpiryDate).format('YYYY-MM-DD')

					}

						this.input = ({
							warehouseid: this.warehouseid,
							clientid:this.Clientname,
							awbno:this.awbno,
							returnsType : this.returnsType,
							expirydate:this.ExpiryDate,
							useremail: this.useremail
						});
						axios({
								method: 'POST',
								'url': apiUrl.api_url + 'updateReturnExpiry',
								'data': this.input,
								headers: {
									'Authorization': 'Bearer ' + myStr,
								}
							})
							.then(response => {
								if (response.data.errorCode == 0) {
									this.is_Loading = false
									this.$alertify.success(response.data.msg)
									// if (response.data.msg1.length > 0){
									// let response1 = JSON.stringify(response.data.msg1);
									// response1 = response1.replace(/,/g,', ')
									// this.$alertify.error(" Invalid IDs :"+response1);
									// }
									this.resetaddDeatilsForm();

								} else if (response.data.errorCode == -1) {
									this.is_Loading = false
									this.$alertify.error(response.data.msg)
									this.resetaddDeatilsForm();

								}
							}, error => {
								console.error(error);
							});
						}
					}).catch(() => {
						console.log('error exist', this.errors)
					});
		},
		UpdateReturnExpiry() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.pageno = 0;
			if (this.showSelectWarehouse == true) {
				this.warehouseid = this.warehousename
			}
			this.$validator.validateAll().then((result) => {
				if (!result) {
					console.log(result);
					console.log('form is invalid', this.model)
					return false;
				} else {
					if(this.ExpiryDate != ''){
						this.ExpiryDate = moment(this.ExpiryDate).format('YYYY-MM-DD')

					}

						this.input = ({
							warehouseid: this.warehouseid,
							clientid:this.Clientname,
							awbno:this.awbno,
							returnsType : this.returnsType,
							expirydate:this.ExpiryDate,
							useremail: this.useremail
						});
						axios({
								method: 'POST',
								'url': apiUrl.api_url + 'updateReturnExpiry',
								'data': this.input,
								headers: {
									'Authorization': 'Bearer ' + myStr,
								}
							})
							.then(response => {
								if (response.data.errorCode == 0) {
									this.is_Loading = false
									this.$alertify.success(response.data.msg)
									// if (response.data.msg1.length > 0){
									// let response1 = JSON.stringify(response.data.msg1);
									// response1 = response1.replace(/,/g,', ')
									// this.$alertify.error(" Invalid IDs :"+response1);
									// }
									this.resetaddDeatilsForm();

								} else if (response.data.errorCode == -1) {
									this.is_Loading = false
									this.$alertify.error(response.data.msg)
									this.resetaddDeatilsForm();

								}
							}, error => {
								console.error(error);
							});
						}
					}).catch(() => {
						console.log('error exist', this.errors)
					});
		},
		resolveReturnsPutAwayIssue(){
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.pageno = 0;
			if (this.showSelectWarehouse == true) {
				this.warehouseid = this.warehousename
			}

			this.$validator.validateAll().then((result) => {
				if (!result) {
					console.log('form is invalid', this.model)
					return false;
				} else {
                    this.input = ({
						warehouseid: localStorage.getItem("selectedWarehouse"),
						clientid:this.client,
						awbno:this.awbnumber,
						processname:this.returnType,
						rackType:this.racktype,
					
					});
                    
					axios({
						method: 'POST',
						'url': apiUrl.api_url + 'fixReturnsPutawayIssue',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr,
						}
					})
					.then(response => {
                        if (response.data.errorCode == 0) {
							this.is_Loading = false
							this.$alertify.success(response.data.msg)
							
							this.resetaddDeatilsForm();

						} else if (response.data.errorCode == -1) {
							this.is_Loading = false
							this.$alertify.error(response.data.msg)
							this.resetaddDeatilsForm();

						}
					})
					
				}

			});
		},
        
		resolveDeleteOrder(){
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.pageno = 0;
			if (this.showSelectWarehouse == true) {
				this.warehouseid = this.warehousename
			}

			this.$validator.validateAll().then((result) => {
				if (!result) {
					console.log('form is invalid', this.model)
					return false;
				} else {
                    this.input = ({
						warehouseid: localStorage.getItem("selectedWarehouse"),
						clientid:this.client,
						userid : this.userid,
						useremail : this.useremail,
						batchsize : 1,
                        ordersdata : [
							{
								"orderid" : this.delorderid,
								"productid" : this.delproductid,
								"itemid" : this.delitemid,
								"boxid" : this.delboxid
							}
						]
					
					});
                    
					axios({
						method: 'POST',
						'url': apiUrl.api_url + 'deleteOrder',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr,
						}
					})
					.then(response => {
                        if (response.data.data.ErrorCode == 0) {
							this.is_Loading = false
							this.$alertify.success(response.data.data.msg)
							
							this.resetaddDeatilsForm();

						} else if (response.data.errorCode == -1) {
							this.is_Loading = false
							this.$alertify.error(response.data.msg)
							this.resetaddDeatilsForm();

						}
					})
					
				}

			});
		},

		resolveExcessGrn(){
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.pageno = 0;
			if (this.showSelectWarehouse == true) {
				this.warehouseid = this.warehousename
			}
			this.$validator.validateAll().then((result) => {
				if (!result) {
					console.log('form is invalid', this.model)
					return false;
				} else {

					if(this.removeacceptqty == 0 && this.removerejectqty == 0 && this.grnitemid == 0 && this.removeshortqty==0) 
                    {
                        this.$alertify.error("Please enter Some Values");
						return false;
					}
					this.input = ({
						warehouseid: localStorage.getItem("selectedWarehouse"),
						clientid:this.client,
						invreferenceid:this.invreferenceid,
						productid:this.grnproductid,
						removeacceptqty:this.removeacceptqty,
						removerejectqty : this.removerejectqty,
						itemid : this.grnitemid,
						removeshortqty : this.removeshortqty
					
					});
                    
					axios({
						method: 'POST',
						'url': apiUrl.api_url + 'fixExcessGRNIssue',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr,
						}
					})
					.then(response => {
                        if (response.data.errorCode == 0) {
							this.is_Loading = false
							this.$alertify.success(response.data.msg)
							
							this.resetaddDeatilsForm();

						} else if (response.data.errorCode == -1) {
							this.is_Loading = false
							this.$alertify.error(response.data.msg)
							this.resetaddDeatilsForm();

						}
					})
					
				}

			});
		},
         updateImageUniToWMS(){
            var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.isLoading = true;
				this.$validator.validateAll().then((result) => {
					if (!result) {
						console.log('form is invalid', this.model)
						return false;
					} else {
							this.input = ({
								clientid: Number(this.client),
								skustring : Array.isArray(this.skustring) ? this.skustring : [this.skustring],
								createdby : this.useremail,
							})

						axios({
								method: 'POST',
								'url': apiUrl.api_url + 'updateImageurlUniwareToWMS',
								'data': this.input,
								headers: {
									'Authorization': 'Bearer ' + myStr
								}
							})
							.then(result => {
							if (result.data.data[0].ErrorCode == -1) {
								this.listStockReportData = [];
								this.resultCount = 0;
								this.totalRows = 0;
								this.$alertify.error(result.data.data[0].msg);
							} else {
								this.$alertify.success(result.data.data[0].msg);
							}
								this.isLoading = false;
							}, error => {
								console.error(error);
							})
					}
				}).catch(() => {
					console.log('errors exist', this.errors)
				});
		 },
		 getPickersList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				warehouseid: window.localStorage.getItem("selectedWarehouse"),
			});
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getWarehousePickerList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					this.pickerListData = result.data.data.data;
				}, error => {
					console.error(error)
				})
		},
		 pickerAssignmentBulk(){
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			this.pickerAssignmentShow = false;
			if (localStorage.getItem("selectedClient") == '') {
				this.$alertify.error(this.$t('common.clientMsg'));
				return false;
			}
			if (this.pickerid == 0) {
				this.$alertify.error(this.$t('common.selectPickerErr'));
				return false;
			}
			if (this.ordertext == '') {
				this.$alertify.error(this.$t('supportRequest.orderIdError'));
				return false;
			}
			this.isLoading = true;
			this.input = {
				clientid: window.localStorage.getItem("selectedClient"),
				warehouseid: window.localStorage.getItem("selectedWarehouse"),
				selectedorder: this.ordertextArray,
				userid: this.userid,
				pickerid: this.pickerid,
			}
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'bulkOrderAssignToPicker',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					if (result.data.data.ErrorCode == 0) {
						this.$alertify.success(result.data.data.msg);
						this.resetaddDeatilsForm();
					} else {
						this.$alertify.error(result.data.data.msg);
						this.resetaddDeatilsForm();
					}
					this.isLoading = false;
					this.pickerid = '';
					this.ordertext = '';

				}, error => {
					console.error(error);
				});
		 },
		resetaddDeatilsForm() {
			this.$validator.reset();
			this.Clientname = '';
			this.orderid = '';
			this.statusupdate = '';
			this.warehousename = '';
			this.Requesttype = '';
			this.BoxID = '';
			this.MultiorderIDS = '';
			this.orderidlist='';
			this.dispatchedbyuser = '';
			this.dispatchedtouser = '';
			this.MultiorderBoxIDS = '';
			this.purchaseorderidlist = '';
			this.awbno = '';
			this.sku = '';
			this.totalquantity = '';
			this.orderid1 = '';
			this.custname = '';
			this.couriername = '';
			this.buttonflag = false;
			this.resultArr = [];
			this.shpmtidArr = [];
			this.ProductID = '';
			this.ExpiryDate = '';
			this.RackID = '';
			this.returnsType='';
            this.returnType = '';
			this.awbnumber = '';
			this.racktype = '';
			this.delorderid ='';
			this.delproductid = '';
			this.delitemid = '';
			this.delboxid = '';
			this.removeshortqty=0,
			this.grnitemid = 0,
			this.removerejectqty = 0,
			this.removeacceptqty = 0,
			this.invreferenceid='',
			this.grnproductid = '',
			this.pushorderid='',
			this.pickerid='',
			this.ordertext='',
			this.SelectPickerErr='',
			this.orderTextErr=''
		},


	}
}



// WEBPACK FOOTER //
// ./src/views/components/supportrequest/supportrequest.component.js